export enum Role {
  admin = 'ADMIN',
  executor = 'EXECUTOR',
  customer = 'CUSTOMER',
  manager = 'MANAGER',
}
